/* NUVA — selector FUNCIONAL de mezcla de categorías por valor (Entrega 11)
   ----------------------------------------------------------------
   Vive dentro de la página REAL de producto de Store/Business/
   Ecommerce (snippets/nuva-mezcla-selector.liquid, anchor
   #personaliza-tu-mezcla, incluido desde sections/main-nuva-level-
   product.liquid) — ya no depende de ningún interruptor de tema ni
   de una sección aparte en la Home. Convierte el saldo de surtido
   incluido en cada plan (composition[cat] × categories[cat].value,
   leído en vivo de snippets/nuva-kit-config.liquid — nunca
   hardcodeado aquí) en un selector real de PROPORCIÓN de categorías
   (pantalones / playeras / shorts / packs de calcetas). NO es un
   selector de modelo, color, talla ni SKU — eso sigue sin existir
   (ver nuva-selector-arquitectura.md). No se muestra compra
   acelerada (PayPal/Shop Pay) en esta página para Store/Business/
   Ecommerce: el formulario de producto de este bloque nunca incluye
   ese marcado, así que no existe ningún botón que pueda saltarse
   esta selección.

   Persistencia de borrador: sessionStorage, por pestaña y por kit
   (nunca localStorage, y nunca es la única vía de guardar la
   selección — la mezcla confirmada viaja como propiedades de línea
   reales del formulario de producto hacia /cart/add.js).

   Validaciones que SÍ ocurren aquí (lado cliente/tema):
   - Enteros, nunca negativos (los steppers solo suman/restan 1).
   - Saldo utilizado debe igualar exactamente el saldo incluido para
     habilitar la confirmación.
   - El id de variante viene fijo desde Liquid (uno por sección/kit),
     nunca se construye ni se edita en JS.
   - Guardia anti doble-clic / doble envío.
   Decisión del usuario (2026-09-24): el cliente NUNCA ve cifras de saldo
   en pesos (ni el saldo incluido, ni el utilizado, ni valores por
   categoría) ni la propiedad "Saldo de surtido utilizado": solo el avance
   y "Surtido completo". El precio cobrado es siempre el del producto en
   Shopify. La lógica de cálculo interna (valores de kit-config) no cambia.
   IMPORTANTE — esto NO es seguridad de servidor. Cualquier persona
   con las herramientas de desarrollador del navegador puede alterar
   estos valores antes de enviarlos. Shopify no ofrece hoy una forma
   nativa de rechazar en el servidor una combinación de propiedades
   de línea inválida; eso requeriría una Shopify Function de
   validación de carrito, una app, o un paso adicional de backend —
   ninguno existe todavía en este proyecto. Ver el reporte de la
   entrega para el detalle completo de esta limitación. */
(function () {
  'use strict';

  var CAT_ORDER = ['pants', 'playeras', 'shorts', 'calcetasPacks'];
  var PROP_LABELS = {
    pants: 'Pantalones',
    playeras: 'Playeras',
    shorts: 'Shorts',
    calcetasPacks: 'Packs de calcetas'
  };

  function getKitConfig(root) {
    var script = root.querySelector('script[data-nuva-kit-config]') || document.querySelector('script[data-nuva-kit-config]');
    if (!script) return null;
    try { return JSON.parse(script.textContent); } catch (e) { return null; }
  }

  function storageKey(kitId) { return 'nuva:surtido:' + kitId; }

  function readDraft(kitId, configVersion) {
    try {
      var raw = sessionStorage.getItem(storageKey(kitId));
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || parsed.configVersion !== configVersion) return null;
      return parsed;
    } catch (e) { return null; }
  }
  function writeDraft(kitId, data) {
    try { sessionStorage.setItem(storageKey(kitId), JSON.stringify(data)); } catch (e) { /* no-op */ }
  }
  function clearDraft(kitId) {
    try { sessionStorage.removeItem(storageKey(kitId)); } catch (e) { /* no-op */ }
  }

  function initSelector(root) {
    if (root._nuvaSurtidoInit) return;

    var config = getKitConfig(root);
    if (!config) return;

    var kitId = root.getAttribute('data-kit-id');
    var kit = (config.kits || []).filter(function (k) { return k.id === kitId; })[0];
    if (!kit) return;

    var body = root.querySelector('[data-nuva-selector-body]');
    if (!body) return; // sin cuerpo funcional en el DOM (p. ej. estado honesto sin activar)

    // Guardia: Start/Growth (o cualquier kit no personalizable) nunca
    // reciben esta lógica, sin importar qué instancia de sección exista.
    if (!kit.customizable) return;

    root._nuvaSurtidoInit = true;

    var categories = (config.categories || []).filter(function (c) {
      return CAT_ORDER.indexOf(c.key) !== -1;
    });
    var catByKey = {};
    categories.forEach(function (c) { catByKey[c.key] = c; });

    var saldoIncluido = 0;
    CAT_ORDER.forEach(function (key) {
      var qtyDefault = kit.composition[key] || 0;
      var val = catByKey[key] ? catByKey[key].value : 0;
      saldoIncluido += qtyDefault * val;
    });

    var modalidadBtns = root.querySelectorAll('[data-nuva-modalidad-btn]');
    var catCards = root.querySelectorAll('[data-nuva-cat]');
    var barEl = root.querySelector('[data-nuva-balance-bar]');
    var msgEl = root.querySelector('[data-nuva-balance-msg]');
    var notaEl = root.querySelector('[data-nuva-balance-nota]');

    // Qué pasa después de la compra: texto de kit-config ("despuesDeCompra"), sin duplicarlo aquí.
    var despuesEl = root.querySelector('[data-nuva-despues-compra]');
    if (despuesEl && kit.despuesDeCompra) despuesEl.textContent = kit.despuesDeCompra;
    var confirmBtn = root.querySelector('[data-nuva-selector-confirm]');
    var errorEl = root.querySelector('[data-nuva-selector-error]');
    var resetBtn = root.querySelector('[data-nuva-selector-reset]');
    var form = confirmBtn ? confirmBtn.closest('form') : null;

    function defaultQuantities() {
      var q = {};
      CAT_ORDER.forEach(function (key) { q[key] = kit.composition[key] || 0; });
      return q;
    }

    var state = {
      modalidad: null, // 'auto' | 'custom'
      quantities: defaultQuantities()
    };

    var draft = readDraft(kitId, config.configVersion);
    if (draft && (draft.modalidad === 'auto' || draft.modalidad === 'custom') && draft.quantities) {
      state.modalidad = draft.modalidad;
      CAT_ORDER.forEach(function (key) {
        var v = draft.quantities[key];
        if (typeof v === 'number' && v >= 0 && Math.floor(v) === v) {
          state.quantities[key] = v;
        }
      });
    }

    var startedDispatched = false;
    function markStarted() {
      if (startedDispatched) return;
      startedDispatched = true;
      if (window.nuvaDispatchEvent) window.nuvaDispatchEvent('start_selection', { kit: kitId });
    }

    function persistDraft() {
      writeDraft(kitId, { configVersion: config.configVersion, modalidad: state.modalidad, quantities: state.quantities });
    }

    function currentUtilizado() {
      var total = 0;
      CAT_ORDER.forEach(function (key) {
        var val = catByKey[key] ? catByKey[key].value : 0;
        total += state.quantities[key] * val;
      });
      return total;
    }

    function currentTotalUnidades() {
      var total = 0;
      CAT_ORDER.forEach(function (key) { total += state.quantities[key]; });
      return total;
    }

    function isCustom() { return state.modalidad === 'custom'; }

    function renderModalidad() {
      modalidadBtns.forEach(function (btn) {
        var val = btn.getAttribute('data-nuva-modalidad-btn');
        var active = val === state.modalidad;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-checked', active ? 'true' : 'false');
      });
      body.hidden = state.modalidad === null;
    }

    function renderCategories() {
      catCards.forEach(function (card) {
        var key = card.getAttribute('data-nuva-cat');
        var cat = catByKey[key];
        if (!cat) return;
        var qty = state.quantities[key];

        var labelEl = card.querySelector('[data-nuva-cat-label]');
        var valueEl = card.querySelector('[data-nuva-cat-value]');
        var qtyEl = card.querySelector('[data-nuva-cat-qty]');
        var subtotalEl = card.querySelector('[data-nuva-cat-subtotal]');
        var downBtn = card.querySelector('[data-nuva-cat-down]');
        var upBtn = card.querySelector('[data-nuva-cat-up]');

        if (labelEl) labelEl.textContent = cat.label;
        // sin valores ni subtotales en pesos (no son cobros ni precios)
        if (valueEl) { valueEl.textContent = ''; valueEl.hidden = true; }
        if (qtyEl) qtyEl.textContent = qty;
        if (subtotalEl) { subtotalEl.textContent = ''; subtotalEl.hidden = true; }

        var editable = isCustom();
        if (downBtn) downBtn.disabled = !editable || qty <= 0;
        if (upBtn) upBtn.disabled = !editable;
      });
    }

    function renderBalance() {
      var utilizado = currentUtilizado();

      var pct = saldoIncluido > 0 ? Math.min(100, (utilizado / saldoIncluido) * 100) : 0;
      if (barEl) {
        barEl.style.width = pct + '%';
        barEl.classList.toggle('is-over', utilizado > saldoIncluido);
      }

      // Mensajes sin cifras: el cliente nunca ve montos de saldo.
      var exact = utilizado === saldoIncluido;
      if (msgEl) {
        if (exact) {
          msgEl.textContent = 'Surtido completo';
        } else if (utilizado > saldoIncluido) {
          msgEl.textContent = 'Tu selección supera el surtido de tu nivel. Quita alguna prenda o usa uno de los cambios para continuar.';
        } else {
          msgEl.textContent = 'Todavía puedes agregar prendas para completar tu surtido.';
        }
      }
      if (notaEl) notaEl.hidden = !exact;

      if (confirmBtn) confirmBtn.disabled = !exact;
      renderSwaps(utilizado);
    }

    var swapDefs = {
      pants_to_short_calceta: { from: [{ key: 'pants', qty: 1 }], to: [{ key: 'shorts', qty: 1 }, { key: 'calcetasPacks', qty: 1 }] },
      playera_to_short_calceta: { from: [{ key: 'playeras', qty: 1 }], to: [{ key: 'shorts', qty: 1 }, { key: 'calcetasPacks', qty: 1 }] },
      short_calceta_to_pants: { from: [{ key: 'shorts', qty: 1 }, { key: 'calcetasPacks', qty: 1 }], to: [{ key: 'pants', qty: 1 }] },
      short_calceta_to_playera: { from: [{ key: 'shorts', qty: 1 }, { key: 'calcetasPacks', qty: 1 }], to: [{ key: 'playeras', qty: 1 }] }
    };

    function swapFeasible(def) {
      return def.from.every(function (f) { return state.quantities[f.key] >= f.qty; });
    }

    function applySwap(name) {
      var def = swapDefs[name];
      if (!def || !isCustom() || !swapFeasible(def)) return;
      def.from.forEach(function (f) { state.quantities[f.key] -= f.qty; });
      def.to.forEach(function (t) { state.quantities[t.key] += t.qty; });
      persistDraft();
      renderAll();
    }

    function renderSwaps(utilizado) {
      var buttons = root.querySelectorAll('[data-nuva-swap]');
      buttons.forEach(function (btn) {
        var name = btn.getAttribute('data-nuva-swap');
        var def = swapDefs[name];
        var enabled = isCustom() && def && swapFeasible(def);
        btn.disabled = !enabled;
      });
    }

    function renderAll() {
      renderModalidad();
      renderCategories();
      renderBalance();
    }

    modalidadBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var val = btn.getAttribute('data-nuva-modalidad-btn');
        if (val === state.modalidad) return;
        markStarted();
        if (val === 'auto') {
          state.quantities = defaultQuantities();
        }
        state.modalidad = val;
        persistDraft();
        renderAll();
        if (errorEl) errorEl.hidden = true;
      });
    });

    catCards.forEach(function (card) {
      var key = card.getAttribute('data-nuva-cat');
      var downBtn = card.querySelector('[data-nuva-cat-down]');
      var upBtn = card.querySelector('[data-nuva-cat-up]');
      if (downBtn) {
        downBtn.addEventListener('click', function () {
          if (!isCustom()) return;
          markStarted();
          state.quantities[key] = Math.max(0, state.quantities[key] - 1);
          persistDraft();
          renderCategories();
          renderBalance();
        });
      }
      if (upBtn) {
        upBtn.addEventListener('click', function () {
          if (!isCustom()) return;
          markStarted();
          state.quantities[key] = state.quantities[key] + 1;
          persistDraft();
          renderCategories();
          renderBalance();
        });
      }
    });

    root.querySelectorAll('[data-nuva-swap]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        markStarted();
        applySwap(btn.getAttribute('data-nuva-swap'));
      });
    });

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        var isDefault = CAT_ORDER.every(function (key) { return state.quantities[key] === (kit.composition[key] || 0); });
        if (!isDefault) {
          var ok = window.confirm('¿Restablecer tu mezcla personalizada a la composición recomendada? Perderás los cambios que hiciste.');
          if (!ok) return;
        }
        state.quantities = defaultQuantities();
        persistDraft();
        renderAll();
        if (errorEl) errorEl.hidden = true;
      });
    }

    var isSubmitting = false;
    if (form) {
      form.addEventListener('submit', function (evt) {
        evt.preventDefault();
        if (isSubmitting) return;
        if (!kit.customizable) return;

        var utilizado = currentUtilizado();
        if (utilizado !== saldoIncluido) return; // defensa adicional: el botón ya está disabled en este caso

        isSubmitting = true;
        if (errorEl) errorEl.hidden = true;
        var originalLabel = confirmBtn.textContent;
        confirmBtn.disabled = true;
        confirmBtn.textContent = 'Agregando…';

        var modalidadLabel = state.modalidad === 'auto' ? 'NUVA elige mi surtido' : 'Quiero personalizar mi mezcla';
        var totalUnidades = currentTotalUnidades();

        // Propiedad privada (prefijo _): modalidad y cantidades para la operación interna.
        // Sin saldo ni valores en pesos: no hacen falta para preparar el pedido (se reconstruyen
        // desde las cantidades y configVersion si alguna vez se necesitan).
        var selectionJson = {
          plan: kitId,
          modalidad: state.modalidad,
          quantities: {
            pants: state.quantities.pants,
            playeras: state.quantities.playeras,
            shorts: state.quantities.shorts,
            calcetasPacks: state.quantities.calcetasPacks
          },
          totalUnidadesComerciales: totalUnidades,
          timestamp: new Date().toISOString(),
          configVersion: config.configVersion
        };

        function setProp(key, value) {
          var input = form.querySelector('[data-nuva-prop="' + key + '"]');
          if (input) input.value = value;
        }
        setProp('modalidad', modalidadLabel);
        setProp('pants', state.quantities.pants);
        setProp('playeras', state.quantities.playeras);
        setProp('shorts', state.quantities.shorts);
        setProp('calcetasPacks', state.quantities.calcetasPacks);
        setProp('total', totalUnidades);
        setProp('json', JSON.stringify(selectionJson));

        var addUrl = confirmBtn.getAttribute('data-cart-add-url');
        var cartUrl = confirmBtn.getAttribute('data-cart-url');
        var formData = new FormData(form);

        fetch(addUrl, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData
        })
          .then(function (res) {
            return res.json().then(function (data) { return { ok: res.ok, data: data }; });
          })
          .then(function (result) {
            if (!result.ok) {
              throw new Error((result.data && (result.data.description || result.data.message)) || 'No pudimos agregar tu mezcla al carrito.');
            }
            if (window.nuvaDispatchEvent) window.nuvaDispatchEvent('finish_selection', { kit: kitId, selection: state.quantities, modalidad: state.modalidad });
            clearDraft(kitId);
            window.location.href = cartUrl || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root + 'cart' : '/cart');
          })
          .catch(function (err) {
            isSubmitting = false;
            confirmBtn.disabled = false;
            confirmBtn.textContent = originalLabel;
            if (errorEl) {
              errorEl.hidden = false;
              errorEl.textContent = 'No pudimos agregar tu mezcla al carrito (' + (err && err.message ? err.message : 'error de conexión') + '). Tu selección sigue guardada — puedes intentar de nuevo.';
            }
          });
      });
    }

    renderAll();
  }

  function initAll() {
    document.querySelectorAll('[data-nuva-selector]').forEach(initSelector);
  }

  initAll();

  document.addEventListener('shopify:section:load', function (evt) {
    var root = evt.target.querySelector('[data-nuva-selector]');
    if (root) initSelector(root);
  });
})();
